<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary pb-2">Nouveau message électronique</h3>
  </div>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="mb-3 row">
          <label class="col-sm-1 col-form-label">De</label>
          <div class="col-sm-11">
            <ng-select
              formControlName="from"
              [items]="[form.controls?.from?.value]"
              [clearable]="false"
              [class.is-invalid]="submitted && form.controls?.from?.invalid"
              >
              <ng-template ng-label-tmp let-item="item">
                <span><strong>Insertis</strong> &#x3c;noreply&#64;grandlyon.com&#x3e;</span>
              </ng-template>
            </ng-select>
            @if (submitted && form.controls?.from?.errors?.required) {
              <small class="form-text text-danger"
                >L'adresse de l'émetteur est obligatoire.</small
                >
              }
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-sm-1 col-form-label">À</label>
            <div class="col-sm-11">
              <ng-select formControlName="to" [items]="[to]" [clearable]="false" [class.is-invalid]="submitted && form.controls?.to?.invalid">
                <ng-template ng-label-tmp let-item="item">
                  <span
                    ><strong>{{ item.name }}</strong> &#x3c;{{ item.email | lowercase }}&#x3e;</span
                    >
                  </ng-template>
                </ng-select>
                @if (submitted && form.controls?.to?.errors?.required) {
                  <small class="form-text text-danger"
                    >L'adresse du destinataire est obligatoire.</small
                    >
                  }
                </div>
              </div>
              <div class="mb-3 row">
                <label class="col-sm-1 col-form-label">Cc</label>
                <div class="col-sm-11">
                  <ng-select
                    [multiple]="true"
                    [hideSelected]="true"
                    formControlName="cc"
                    [items]="contacts"
                    [clearable]="false"
                    notFoundText="Aucun contact n'a été trouvé."
                    [compareWith]="compareContacts"
                    [searchFn]="searchContacts"
                    >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label"
                        ><strong>{{ item.name }}</strong> &#x3c;{{ item.email | lowercase }}&#x3e;</span
                        >
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">x</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$" let-search="searchTerm">
                        <div>
                          <h6 class="my-0">{{ item.name }}</h6>
                          <small class="text-muted">{{ item.email }}</small>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-1 col-form-label">Objet</label>
                  <div class="col-sm-11">
                    <input type="text" class="form-control" formControlName="subject" />
                  </div>
                </div>
                <!-- ********************************************************************************************* -->
                <!-- * ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTAC * -->
                <!-- * ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTACHMENTS ATTAC * -->
                <!-- ********************************************************************************************* -->
                @if (attachmentsForm) {
                  <div [formGroup]="attachmentsForm">
                    <div class="mb-3">
                      <small>
                        <strong> Pièces jointes </strong>
                      </small>
                    </div>
                    <div formArrayName="attachments">
                      @for (attachment of attachments.controls; track attachment; let i = $index) {
                        <div class="row mb-2" [formGroupName]="i">
                          <div class="col-12 col-lg-10 mb-2">
                            <app-file-input
                              formControlName="document"
                  [invalid]="
                    $any(attachments.controls[i])?.controls?.document?.errors?.fileSize ||
                    (submitted && $any(attachments.controls[i])?.controls?.document?.errors)
                  "
                              title="autre"
                              accept="application/pdf,image/png,image/jpeg"
                              [maxFileSize]="maxFileSize"
                              [renameWithBeneficiaryData]="false"
                            ></app-file-input>
                          </div>
                          <div class="col-12 col-lg-2 mb-lg-2 d-flex justify-content-end">
                            <button type="button" class="btn btn-outline-primary ms-3 rounded" ngbTooltip="Supprimer" (click)="removeAttachment(i)">
                              <fa-icon icon="trash-alt"></fa-icon>
                            </button>
                            <button type="button" class="btn btn-primary ms-3 rounded" ngbTooltip="Ajouter" (click)="addAttachment()" [class.invisible]="i > 0">
                              <fa-icon icon="plus"></fa-icon>
                            </button>
                          </div>
                          @if ($any(attachments.controls[i])?.controls?.document?.errors?.fileSize) {
                            <small class="form-text text-danger ms-3">
                              La pièce jointe ne doit pas dépasser {{ maxFileSizeStr }}.
                            </small>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="mb-3 row">
                  <div class="col-12">
                    <app-text-editor class="w-100" formControlName="content" [class.invalid]="submitted && form.controls?.content?.invalid"></app-text-editor>
                    @if (submitted && form.controls?.content?.errors?.required) {
                      <small class="form-text text-danger"
                        >Le contenu du message est obligatoire.</small
                        >
                      }
                    </div>
                  </div>
                </div>
                <div class="row px-3">
                  <div class="d-grid ms-lg-auto col-3 col-md-6 col-lg-3 mb-1">
                    <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
                      <fa-icon icon="ban"></fa-icon>
                      <span class="ms-3 d-none d-md-block">Annuler</span>
                    </button>
                  </div>
                  <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
                    <button class="btn btn-primary d-flex justify-content-center" type="submit">
                      <fa-icon icon="envelope"></fa-icon>
                      <span class="ms-3 d-none d-md-block">Envoyer</span>
                    </button>
                  </div>
                </div>
              </form>
            }
          </div>
